import { z } from "zod";

const addCommentSchema = z.object({
  content: z.string().min(1),
});
type AddCommentFormData = z.infer<typeof addCommentSchema>;

export { addCommentSchema };
export type { AddCommentFormData };
